import {
  castArray,
  forOwn,
  isFunction,
  isNull,
} from 'lodash';
import Types from './Types';

const helpers = {
  buildFullKey(parentKey, key) {
    if (!parentKey) return key;
    return `${parentKey}.${key}`;
  },
  sanitizeFieldName(fieldOpt, typeOptOrFunc, key) {
    if (isNull(fieldOpt) || fieldOpt === false) return null;
    let typeOpt = typeOptOrFunc;
    if (isFunction(typeOpt)) typeOpt = typeOpt(key);
    if (isNull(typeOpt) || typeOpt === false) return null;
    return fieldOpt || typeOpt || key;
  },
  getItemDefinition(parentKey, schemaOpts) {
    if (!schemaOpts) return undefined;
    return this.getFieldDefinitionWithParent(parentKey, undefined, schemaOpts);
  },
  getFieldDefinitionWithParent(parentKey, key, schemaOpts) {
    const opts = schemaOpts === true ? {} : schemaOpts;
    const type = opts.type || Types.Default;
    const defaultArg = ('default' in opts) ? opts.default : type.default;

    let defaultFunc;
    if (isFunction(defaultArg)) {
      defaultFunc = defaultArg;
    } else {
      defaultFunc = () => defaultArg;
    }

    return {
      default: defaultFunc,
      dump: opts.dump || type.dump.bind(type),
      dumpTo: this.sanitizeFieldName(opts.dumpTo, type.dumpTo.bind(type), key),
      mapToDefault: opts.mapToDefault || type.mapToDefault.bind(type),
      isPresent: opts.isPresent || type.isPresent.bind(type),
      load: opts.load || type.load.bind(type),
      loadFrom: this.sanitizeFieldName(
        opts.loadFrom, type.loadFrom.bind(type), key,
      ),
      loadErrors: opts.loadErrors || type.loadErrors.bind(type),
      loadErrorsFrom: this.sanitizeFieldName(
        opts.loadErrorsFrom, type.loadErrorsFrom.bind(type), key,
      ),
      key,
      required: opts.required || false,
      validators: castArray(opts.validate || []),
    };
  },
  getNestedFieldDefinitions(parentKey, parentType) {
    const definitions = {};
    if (parentType.nestedSchema) {
      forOwn(parentType.nestedSchema, (schemaOpts, key) => {
        const definition =
          this.getFieldDefinitionWithParent(parentKey, key, schemaOpts);
        definitions[key] = definition;
      });
    }
    return definitions;
  },
  getFieldDefinitionsWithParent(parentKey, parentSchemaOpts) {
    const fields = {};
    forOwn(parentSchemaOpts, (schemaOpts, key) => {
      const definition =
        this.getFieldDefinitionWithParent(parentKey, key, schemaOpts);
      fields[key] = definition;
    });
    return fields;
  },
};

export function getFieldDefinition(key, options) {
  return helpers.getFieldDefinitionWithParent(undefined, key, options);
}

export function getFieldDefinitions(schemaOpts) {
  return helpers.getFieldDefinitionsWithParent(undefined, schemaOpts);
}



// WEBPACK FOOTER //
// ./mixins/Form/Definitions.js